// ** react imports
import React, { useState } from 'react';

// ** components imports
import UserPanel from '../../../views/users/UserDetails/UserPanel';
import UserSettingsSidebar from '../../../views/users/UserDetails/UserSettingsSidebar';

function UsersDetails() {
  return (
    <div className="flex ">
      <main className="grow">
        <div className="px-4 sm:px-6 lg:px-8 py-6 w-full max-w-[96rem] mx-auto">
          {/* Page header */}
          <div className="mb-8">
            {/* Title */}
            <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">
              Profile
            </h1>
          </div>

          {/* Content */}
          <div className="bg-white dark:bg-gray-800 shadow-xs rounded-xl mb-8">
            <div className="flex flex-col md:flex-row md:-mr-px">
              <UserSettingsSidebar />
              <UserPanel />
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default UsersDetails;
